import { render, staticRenderFns } from "./CrewActivity.vue?vue&type=template&id=b5569dec&scoped=true"
import script from "./CrewActivity.vue?vue&type=script&lang=js"
export * from "./CrewActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5569dec",
  null
  
)

export default component.exports